// extracted by mini-css-extract-plugin
export default {"wrapper":"style__wrapper___1l7Vk"};